import React from 'react';
import cn from 'classnames';
import env from '../../utils/env';
import styles from './styles.module.scss';

interface Props {
  text?: React.ReactNode;
  img?: any;
  inline?: boolean;
}

export default function EmptyView(props: Props) {
  const { isApp } = env;
  const defaultText = isApp
    ? '哎呀，我们没有捕捉到数据，歇会再来'
    : '未查询到结果。';

  return (
    <div className={cn(styles.emptyView, { [styles.inline]: props.inline })}>
      <img
        className={styles.img}
        alt=""
        src={props.img || require(`./images/empty.png`)}
      />
      <div className={styles.t}>{props.text || defaultText}</div>
    </div>
  );
}

EmptyView.defaultProps = {
  inline: false,
};
